import { CareType } from '@/types/care_type';

const getCareTypeOptions = (): { display: string; value: string }[] => {
  return [
    { display: 'Babysitter', value: CareType.BABYSITTER },
    { display: 'Nanny', value: CareType.NANNY },
    { display: 'Housekeeper', value: CareType.HOUSEKEEPING },
    { display: 'Pet care', value: CareType.PET_CARE },
    { display: 'Special needs', value: CareType.SPECIAL_NEEDS },
    { display: 'Care companion', value: CareType.COMPANION_CARE },
  ];
};

export default getCareTypeOptions;
